// extracted by mini-css-extract-plugin
export default {"main_section":"about_main_section__2IyVS","aboutChild":"about_aboutChild__U1iTA","btn":"about_btn__c0blm"};